// extracted by mini-css-extract-plugin
export default {"modal":"BaseDocuments_modal__z1xGJ"};